import * as connectedReactRouter from 'connected-react-router'
import * as types from './types'

// Errors

export const ERROR_MESSAGES = {
  messages: ['Código de autenticação inválido']
}

export const receiveError = () => {
  const err = ERROR_MESSAGES

  const newError = {
    hasError: true,
    messages: err?.messages
  }

  return {
    type: types.RECEIVE_AUTH_ERROR,
    payload: newError
  }
}

export const resetError = () => ({
  type: types.RESET_AUTH_ERROR
})

// General Auth

export const fetchAuth = (value = true) => ({
  type: types.FETCH_AUTH,
  payload: value
})

export const receiveAuth = (value = true) => ({
  type: types.RECEIVE_AUTH,
  payload: value
})

export const resetAuth = () => ({
  type: types.RESET_AUTH
})

// Redirect Page

export const receiveConfirmPageUrl = (value) => ({
  type: types.RECEIVE_CONFIRM_PAGE_URL,
  payload: value
})

export const redirectConfirmPageUrl = () => (dispatch, getState) => {
  const route = getState()?.authReducer?.content?.confirmPageUrl

  dispatch(connectedReactRouter.routerActions.push(route))
}

// SLT Token

export const receiveAuthSLT = (value) => ({
  type: types.RECEIVE_AUTH_SLT,
  payload: value
})

export const getAuthSLT = () => (_, getState) =>
  getState()?.authReducer?.content?.slt
